import { IPeriodNames } from 'components/BusinessToolForm/constants/periods';

const sortByNumbers = (a: string, b: string): number => {
  return Number(a.replace(/\D/g, "")) - Number(b.replace(/\D/g, ""))
}

export const getEachRowValues = (
  fieldValues: Record<string, string>[] | Record<string, Record<string, string>>[],
  index: number,
  period: IPeriodNames,
  needToSortObjectKeys: boolean = false,
  needToConvertToNegative: boolean = false,
) => {
  if (!fieldValues[index] || !fieldValues[index][period]) return [];
  if (needToSortObjectKeys) {
    const sortedKeys = Object.keys(fieldValues[index][period]).sort(sortByNumbers);
    return sortedKeys.map((key) => (fieldValues[index] as Record<string, Record<string, string>>)[period][key]);
  }

  return Object.values(fieldValues[index][period]).map(item => needToConvertToNegative ? (+item * (-1)).toString() : item);
};
